import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67575d5b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "booster" }
const _hoisted_2 = { class: "booster-container" }
const _hoisted_3 = { class: "booster-container__box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"auto"} }, ":", -1 /* HOISTED */))
const _hoisted_5 = { class: "booster-container__box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"auto"} }, ":", -1 /* HOISTED */))
const _hoisted_7 = { class: "booster-container__box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"auto"} }, ":", -1 /* HOISTED */))
const _hoisted_9 = { class: "booster-container__box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('BOOST.COUNTER.STARTS_IN')), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, _toDisplayString($setup.days) + "D", 1 /* TEXT */),
        _createCommentVNode("        <div>{{$t('BOOST.COUNTER.DAYS')}}</div>")
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, _toDisplayString($setup.hours.toString().padStart(2, '0')) + "H", 1 /* TEXT */),
        _createCommentVNode("        <div>{{$t('BOOST.COUNTER.HOURS')}}</div>")
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, _toDisplayString($setup.minutes.toString().padStart(2, '0')) + "M", 1 /* TEXT */),
        _createCommentVNode("        <div>{{$t('BOOST.COUNTER.MINUTES')}}</div>")
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, _toDisplayString($setup.seconds.toString().padStart(2, '0')) + "S", 1 /* TEXT */),
        _createCommentVNode("        <div>{{$t('BOOST.COUNTER.MINUTES')}}</div>")
      ])
    ])
  ]))
}